import { Bell, MapPin, Radio, Users } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Section } from "@/components/layout/section";

const FEATURES = [
  {
    icon: Radio,
    title: "Pantauan Real-Time",
    description:
      "Laporan insiden tersampaikan secara instan ke petugas dan warga di sekitar lokasi Anda.",
  },
  {
    icon: MapPin,
    title: "Pemetaan Patroli",
    description:
      "Lacak rute ronda dan titik rawan langsung di peta interaktif yang selalu terkini.",
  },
  {
    icon: Bell,
    title: "Peringatan Dini",
    description:
      "Notifikasi otomatis saat ada aktivitas mencurigakan di area yang Anda awasi.",
  },
  {
    icon: Users,
    title: "Komunitas Terhubung",
    description:
      "Warga, ketua RT/RW, dan petugas keamanan berkolaborasi dalam satu ruang digital.",
  },
];

export function Features() {
  return (
    <Section id="fitur">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold sm:text-4xl">Fitur yang Menjaga Malam</h2>
        <p className="mt-4 text-text-muted">
          Dirancang agar keamanan lingkungan menjadi lebih terorganisir, transparan, dan cepat
          tanggap.
        </p>
      </div>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map(({ icon: Icon, title, description }) => (
          <Card key={title} className="transition-transform duration-200 hover:-translate-y-1">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent/10 text-accent">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-4 text-lg font-semibold">{title}</h3>
            <p className="mt-2 text-sm text-text-muted">{description}</p>
          </Card>
        ))}
      </div>
    </Section>
  );
}
